import React from "react";
import Barcode from 'react-barcode';
import ProductLong_776 from "components/Labels/ProductLong_776";

/**
 * @param {Products_Object} product
 * @param visible
 */
export default ({product, visible = false}) => {

	let maxCharacters = 12;
	let minCharacters = 5;

	let cutBarCodeText = (text)=> {
		return text.substr(0, maxCharacters);
	};
	let cutBarCodeTextExtra = (text)=> {
		return ' ' + text.substr(maxCharacters);
	};
	let getBarCodeWidth = (text) => {
		let smallest = 1.6;
		let largest = 2.5;
		let range = largest - smallest;
		let charRange = maxCharacters - minCharacters;
		let widthSegmentPerCharacter = range / charRange;
		let charsOverMin = text.length - minCharacters;
		let additionalSize = widthSegmentPerCharacter * charsOverMin;
		let newSize = largest - additionalSize;
		return Math.min(Math.max(newSize, smallest), largest);
	};

	let value = product.id ? product.id : ('P-'+parseInt(product.binary_id.trim())+'-'+product.pkey);
	let icn = product.binary_id + '-' + product.pkey;

	return (
		<div className="ProductLong" style={{
			textAlign:"center",
			width: '285px',
			height: '382px',

			... visible ? {
				border: '1px solid black',
				borderRadius: '10px',
				display: 'inline-block'
			} : {
				pageBreakBefore: 'always',

				marginLeft:"1px",
			}
		}}>
			<div style={{ borderBottom : '2px solid black', marginTop: '30px'}}>
				{product.price_list && <span className="priceList" style={{fontSize:'25px'}}> Price : ${product.price_list}<br/></span>}
			</div>

			<div className="notes" style={{fontSize:"20px", borderBottom:'2px solid black'}}>
				<b>
					<div style={{marginTop: '5px', marginBottom:'6px'}}>{!product.manufacturer_other && product.manufacturers ? product.manufacturers.name : product.manufacturer_other}</div>

					<div style={{marginBottom:'6px'}}>{product.model}</div>

					<div style={{marginBottom:'6px'}}>{!product.caliber_other && product.calibers ? product.calibers.name : product.caliber_other}</div>
					{product.tag_note && <div style={{marginBottom:'8px'}}>{product.tag_note}</div>}
				</b>
			</div>

			<div className="serialNumber" style={{padding: '20px 0 10px 0', fontSize:'20px'}}>
				{product.serial_number}
			</div>
			<div className="barCode" style={{marginBottom: 10}}>
				<Barcode format={'CODE128A'}
				         value={cutBarCodeText(value)}
				         height={30}
				         margin={0}
				         width={getBarCodeWidth(value)}
				         displayValue={false} />
			</div>

			<div className="notes" style={{padding:"10px 0 5px 0", marginBottom:'25px'}}>
				<img src="/assets/images/account_2940_Logo.png" style={{width: '100px'}} alt={"Jerry's Logo"}/>
			</div>
			<div style={{fontSize:"20px", borderBottom:'2px solid black', marginBottom: '15px', paddingBottom: '5px'}}>
				<b>{icn}</b>
			</div>
			<div style={{fontSize:'25px'}}>
				<b>{icn}</b>
			</div>

		</div>
	);
};
